// extracted by mini-css-extract-plugin
export default {"tagsWrapper":"styles_tagsWrapper__HbKin","tagTitle":"styles_tagTitle__Vxjo9"};